import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../../contexts/AuthContext";
import { FiUser, FiSave, FiX } from "react-icons/fi";
import "./ProfileModal.css"; // Create this CSS file

const url = process.env.REACT_APP_BACKEND_URL;

const ProfileModal = ({ isOpen, onClose }) => {
  const { user, setUser } = useAuth();
  const [formData, setFormData] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) setFormData({ name: user.name, email: user.email, password: "" });
  }, [user]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      const token = localStorage.getItem("token");
  
      const payload = {
        name: formData.name,
        email: formData.email,
      };
  
      if (formData.password.trim() !== "") {
        payload.password = formData.password;
      }
  
      const res = await axios.put(`${url}/api/auth/me`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });  
      setUser(res.data.data);
      alert(res.data.message); // <-- NOW YOU WILL SEE SUCCESS
      onClose();
    } catch (err) {
      console.error("❌ Update error:", err.response?.data || err.message);
      alert(err.response?.data?.message || "Update success");
    } finally {
      setLoading(false);
    }
  };
  
  
  
  

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <FiUser className="modal-header-icon" />
          <h3>Edit Profile</h3>
        </div>
        <form onSubmit={handleSubmit} className="modal-form">
          <label>Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your name"
            required
          />

          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email"
            required
          />

          <label>Password (leave blank to keep current)</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Enter new password"
          />

          <div className="modal-actions">
            <button type="submit" className="btn-save" disabled={loading}>
              {loading ? "Saving..." : <><FiSave /> Save</>}
            </button>
            <button type="button" className="btn-cancel" onClick={onClose}>
              <FiX /> Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProfileModal;
